import { Tracker } from '@/service'
const PAGES_HANDLERS = ['onLoad', 'onShow', 'onHide', 'onUnload']
const ROUTER_HISTORY_MAP = {
  'pages/index': ['pages/index', '首页', '苹果首页'],
  'pages/store/map-store': ['pages/store/map-store', 'LBS定位', '你身边的门店'],
  'pages/member/index': ['pages/member/index', '我的', '个人中心'],
  'pages/home/search-goods': ['pages/home/search-goods', '产品门店搜索', '产品门店搜索']
}

const SOURCE_ENTRANCE_MAP = {
  'pages/store/map-store': {
    handleStoreItemClick: '探索门店tab'
  }
  // "pages/index":{
  //   onShareAppMessage:"分享测试"
  // }
}

// templantMethodsProxy 对初始化模版内事件进行代理
/**
 * methods_name : [[event1_name,event2_name],[event1_key,event2_key,],[event1_opts,event2_opts]]
 */
const TEMPLANT_METHODS_MAP = {
  onShareAppMessage: [['Tracker'], ['postUV'], [{ type: '单聊' }]],
  onShareTimeline: [['Tracker'], ['postUV'], [{ type: '朋友圈' }]]
}
// 与 TEMPLANT_METHODS_MAP 关联，代理组件事件后要执行 hook队列
const EVENT_LIST = {
  Tracker: (key = '', opts = {}) => {
    Tracker.dispatch(key, opts)
  }
}

/**
 * source_entry_var_map : routerLink 映射 source_entry_var
 */
const SOURCE_ENTRANCE_PATH_MAP = {
  'pages/goods/goods-detail': {
    'pages/index': '首页你身边的热卖产品',
    'pages/index*pages/custom/custom-page': '礼遇推荐',
    'pages/store/map-store*pages/store/index': '门店你身边的热卖产品',
    'pages/member/index*pages/member/coupon*pages/member/coupon-detail': '卡券详情',
    'pages/index*pages/home/search-goods*pages/store/index': '门店你身边的热卖产品'
  },
  'pages/store/index': {
    'pages/index*pages/home/search-goods': '首页搜索门店'
  },
  'pages/store/map-store': {
    'pages/index': '探索门店tab'
  }
}

const RETURN_PATH = ['pages/index', 'pages/member/index', 'pages/store/map-store']

const API_TRACK = {
  '/jurisdiction/permission': [['Tracker'], ['sp_save_upv'], [{}]],
  '/members/member': [['Tracker'], ['sp_save_upv'], [{}]]
}

export default {
  RETURN_PATH,
  PAGES_HANDLERS,
  ROUTER_HISTORY_MAP,
  SOURCE_ENTRANCE_MAP,
  TEMPLANT_METHODS_MAP,
  EVENT_LIST,
  SOURCE_ENTRANCE_PATH_MAP,
  API_TRACK
}
